import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../components/Icon";
import { showSuccess, showError } from "../../../services/toast.service";

const Panel = ({ selectedSessionGroups = [], onDeleteSelected, onClearSelection, onDuplicateSelected }) => {
  const handleDeleteSelected = async () => {
    if (!selectedSessionGroups.length) return;
    
    try {
      await onDeleteSelected(selectedSessionGroups);
      showSuccess(`${selectedSessionGroups.length} groupe(s) de session supprimé(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des groupes de sessions');
      console.error(error);
    }
  };
  
  const handleDuplicateSelected = async () => {
    if (!selectedSessionGroups.length) return;
    
    try {
      await onDuplicateSelected(selectedSessionGroups);
      showSuccess(`${selectedSessionGroups.length} groupe(s) de session dupliqué(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la duplication des groupes de sessions');
      console.error(error);
    }
  };

  // Ne pas afficher le panel s'il n'y a pas de groupes de sessions sélectionnés
  if (!selectedSessionGroups.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedSessionGroups.length} groupe{selectedSessionGroups.length > 1 ? 's' : ''} sélectionné{selectedSessionGroups.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke", styles.button)} onClick={handleDuplicateSelected}>
          <Icon name="copy" size="24" />
          <span>Dupliquer</span>
        </button>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleDeleteSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
